import { useGetCounterRates } from '../../../hooks/useGetCounterRates'
import { IBaseCounter } from './types'
import { useStyletron } from 'baseui'
import { LoadingView } from '../../../components'
import ReferencedRate from './ReferencedRate'
import NoRateReferenced from './NoRateReferenced'
import { energyRateModelId, co2RateModelId, costRateModelId, schemaCO2Rate, schemaCostRate } from '../../Energy/EnergyRates'
import LinkRate from './LinkRate'


const ReferencedRates = (props: IBaseCounter) => {
    const [css, theme] = useStyletron()
    const { items, count, isLoading, isSuccess, refetch } = useGetCounterRates(props.id, props.resourceGroupId);

    const hasCo2Rate = (items?.filter(v => v.schema === schemaCO2Rate).length ?? 0) > 0;
    const hasCostRate = (items?.filter(v => v.schema === schemaCostRate).length ?? 0) > 0;

    const handleRefetch = () => {
        setTimeout(() => {
            refetch();
        }, 3000);
    };

    return (
        <LoadingView isLoading={isLoading} isSucess={isSuccess}>
            <ul
                className={css({
                    paddingLeft: 0,
                    paddingRight: 0,
                    minWidth: '350px'
                })}
            >
                {items?.map(elm => <ReferencedRate onUnlinked={handleRefetch} key={props.id} item={elm} {...props}></ReferencedRate>)}
            </ul>
            {!hasCostRate &&
                <NoRateReferenced rateModelId={costRateModelId} {...props}
                    endEnhancer={<LinkRate onRateLinked={handleRefetch} rateModelId={costRateModelId} {...props}></LinkRate>} >
                </NoRateReferenced>}
            {!hasCo2Rate &&
                <NoRateReferenced rateModelId={co2RateModelId} {...props}
                    endEnhancer={<LinkRate onRateLinked={handleRefetch} rateModelId={co2RateModelId} {...props}></LinkRate>}            >
                </NoRateReferenced>}
        </LoadingView>
    )
}

export default ReferencedRates